import React from 'react';
import { Backoffice } from '~/ui/assets/icons';
import { Menu } from 'antd';
import * as icons from '~/ui/assets/icons';
import { Link } from 'react-router-dom';
import { useDrawer } from '~/hooks/useDrawer';
import { MenuItem } from '../Menu';
import { HamburguerContainer, IconContainer, MenuItemContainer, OptionContainer } from './Hamburguer.styled';

type HamburguerProps = {
  items: MenuItem[];
};

export function Hamburguer({ items }: HamburguerProps) {
  const { closeDrawer } = useDrawer();
  const { SubMenu, Item } = Menu;

  const renderMenuItems = (menuItems: MenuItem[]) =>
    menuItems.map((item, index) => {
      const Icon = icons[item.icon];

      if (item.items && item.items.length > 0) {
        return (
          <SubMenu
            key={item.title + index}
            title={
              <span className="itemGroup">
                {Icon && <Icon style={{ marginRight: 8 }} />}
                {item.title}
              </span>
            }
          >
            {item.items.map((subItem, subIndex) => (
              <MenuItemContainer
                key={subItem.title + subIndex}
                to={subItem.path}
                onClick={() => closeDrawer('menu-drawer')}
              >
                <span>{subItem.title}</span>
              </MenuItemContainer>
            ))}
          </SubMenu>
        );
      }

      return (
        <Item>
          <Link
            key={item.title + index}
            to={item.path}
            className="itemGroup"
            onClick={() => closeDrawer('menu-drawer')}
          >
            {Icon && <Icon style={{ marginRight: 8 }} />}
            {item.title}
          </Link>
        </Item>
      );
    });

  return (
    <HamburguerContainer>
      <IconContainer>
        <Backoffice width={110} height={25} />
      </IconContainer>
      <OptionContainer>
        <Menu style={{ width: 256 }} mode="inline">
          {renderMenuItems(items)}
        </Menu>
      </OptionContainer>
    </HamburguerContainer>
  );
}
